<template>
    <van-popup class="common-pop" v-model:show="visible" position="bottom" close-on-popstate round :z-index="3001" @closed="handleClose">
        <div class="pop-content">
            <div class="pop-title">{{ $t(title) }}</div>
            <div class="pop-inner">
                <slot></slot>
            </div>
        </div>
    </van-popup>
</template>
<script setup lang="ts">
defineProps({
    title: {
        type: String,
        default: () => '',
    },
})
const visible = defineModel()

const handleClose = () => {
    visible.value = false
}
</script>
<style lang="scss" scoped>
.common-pop {
    margin-left: 30px;
    width: 690px;
    font-family: MicrosoftYaHei;
    font-size: 40px;
    background-color: #42355a;
    border-radius: 40px 40px 0px 0px;
    overflow: hidden;

    .pop-title {
        @apply flex justify-center items-center;
        height: 108px;
        background: url('@/assets/img/dialog/title_bg.png') no-repeat;
        background-size: 100% 100%;
        font-weight: bold;
        font-size: 40px;
        color: #fff;
    }
}
</style>
